import { AxiosInstance } from 'axios'
import { Environment } from '../../../Config/constants'
import { Result } from '../../../Shared/Protocol/protocol-result'
import { IHubOrdersByStatusResponse, IHubOrdersTimelineResponse } from './hub-dashboard.interface'

export class HubDashboardApiRemoteService {
  constructor(private service: AxiosInstance) {}

  public getListTotal = async (endpoint: string): Promise<Result<number>> => {
    try {
      const response = await this.service.get(endpoint, {
        params: {
          page: 1,
          offset: Number(Environment.OFFSET_REGISTERS) || 10,
        },
      })

      return Result.ok(response.data?.total ?? 0)
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error)
    }
  }

  public getOrdersByStatusAggregated = async (): Promise<Result<IHubOrdersByStatusResponse | null>> => {
    try {
      const response = await this.service.get('/dashboard/hub/orders-by-status')
      return Result.ok(response.data ?? null)
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error)
    }
  }

  public getOrdersTimeline = async (days = 30): Promise<Result<IHubOrdersTimelineResponse | null>> => {
    try {
      const response = await this.service.get('/dashboard/hub/orders-timeline', {
        params: { days },
      })
      return Result.ok(response.data ?? null)
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error)
    }
  }
}
